'use strict';

/**
 * Notification Service
 */
module.service('notificationResolveService', [ '$q', '$timeout', notificationResolveServiceFn ]);

function notificationResolveServiceFn($q, $timeout) {

	var mNotificationResolve = undefined;
	var mPromise = $q.defer();

	function init() {
		if (angular.isUndefined(mNotificationResolve)) {
			mNotificationResolve = new NotificationResolver('notification-values.json');
			mNotificationResolve.init().success(function() {
				//console.log(mNotificationResolve);
				// $timeout(function(){mPromise.resolve('@ok@');}, 1000);
				mPromise.resolve('@ok@');
			}).error(function() {
				alert("failed load notification values");
				mPromise.reject('fallo');
			});
		}
	}

	init();

	function _byId(n) {
		return n.id == this;
	}
	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */

	var ss = {};

	ss.getPromise = function() {
		return mPromise.promise;
	}

	ss.isReady = function() {
		return mPromise.promise.$$state.status != 0;
	}

	ss.getById = function(idMessage) {
		return cloneObject(mNotificationResolve.values.find(_byId, idMessage));
	};

	return ss;
}
